import React, { useState } from "react";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import termBg from "../../../src/image/term-bg.png";

export default function PrivacyPolicy() {
document.title = "Nexawage Payroll| Privacy Policy"
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="terms-page">
      {/* header */}
      <div className="term-condition">
        <div className="">
          <div className="header-container">
            <div className="logo" onClick={() => navigate("/")}>
              <img
                src="\assets\images\Nexawage_new_logo.png"
                alt="NexaWage Logo"
              />
              <h2>NexaWage Payroll</h2>
            </div>

            <div className="header-actions">
              <Button
                label="Login"
                className="p-button-rounded desktop-login"
                style={{
                  padding: "8px 26px",
                  borderRadius: "8px",
                  background: "#41486b",
                  color: "#fff",
                  fontSize: "16px",
                }}
                onClick={() => navigate("/login")}
              />

              <Button
                className="hamburger"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <i className={`pi ${menuOpen ? "pi-times" : "pi-bars"}`}></i>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${termBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Privacy Policy</h1>
            <p>
              At NexaWage Payroll, we respect your privacy and are committed to
              protecting your personal information. This Privacy Policy explains
              how we collect, use, and safeguard your data when you use our
              website and payroll services.
            </p>
          </div>
        </div>
      </section>

      {/* Terms Container */}
      <section className="terms-container">
        <div className="term-item">
          <h2>1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul className="list-disc ml-6">
            <li>
              Personal Information: Name, email address, phone number, business
              details.
            </li>
            <li>
              Payroll Data: Employee salary details, deductions (CPP, EI,
              Federal Tax), pay periods.
            </li>
            <li>
              Technical Information: IP address, browser type, device details.
            </li>
          </ul>
        </div>

        <Divider />

        <div className="term-item">
          <h2>2. How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul className="list-disc ml-6">
            <li>Generate paystubs and payroll reports (e.g., PD7A).</li>
            <li>Provide customer support and service updates.</li>
            <li>Send notifications via email or WhatsApp.</li>
            <li>
              Improve our platform and ensure compliance with CRA regulations.
            </li>
          </ul>
        </div>

        <Divider />

        <div className="term-item">
          <h2>3. Data Sharing</h2>
          <ul className="list-disc ml-6">
            <li>We do not sell or trade your personal data.</li>
            <li>
              We may share information with trusted service providers (e.g.,
              cloud hosting, communication APIs) to operate our services.
            </li>
            <li>
              Data may be disclosed if required by law or regulatory
              authorities.
            </li>
          </ul>
        </div>

        <Divider />

        <div className="term-item">
          <h2>4. Data Security</h2>
          <ul className="list-disc ml-6">
            <li>
              We use encryption, secure servers, and restricted access to
              protect your data.
            </li>
            <li>
              While we take strong precautions, no method of transmission is
              100% secure.
            </li>
          </ul>
        </div>

        <Divider />

        <div className="term-item">
          <h2>5. User Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc ml-6">
            <li>Access, update, or correct your information.</li>
            <li>Request deletion of your data.</li>
            <li>Opt out of marketing communications.</li>
          </ul>
        </div>

        <Divider />

        <div className="term-item">
          <h2>6. Cookies &amp; Tracking</h2>
          <ul className="list-disc ml-6">
            <li>
              We may use cookies to improve user experience and track website
              usage.
            </li>
            <li>You can disable cookies in your browser settings.</li>
          </ul>
        </div>

        <Divider />

        <div className="term-item">
          <h2>7. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, contact us at: {" "}
            <a href="mailto:payroll@nexawage.com" target="_blank">
              payroll@nexawage.com
            </a>
          </p>
        </div>
      </section>

      {/* Footer */}

      <Footer />
    </div>
  );
}
